module.exports = __webpack_public_path__ + "assets/26.jpg?1eb3acaf4d2683204f370742b7bac6f8";